define(["dojo/i18n", "/local/buildagent/work/71550ad6d48e14da/node_modules/dojo-webpack-plugin/loaders/dojo/runner.js"
,"/local/buildagent/work/71550ad6d48e14da/assets/js/nls/cloudCenterStringResource.js?absMid=nls/cloudCenterStringResource"
], function(loader, runner) {
   return runner(loader, "nls/cloudCenterStringResource", __webpack_require__.dj.c(), true);
});